// Global JavaScript for Oceus Shopify Theme

// Theme object to store global functionality
window.OceusTheme = {
  // Initialize theme
  init: function() {
    this.initMobileMenu();
    this.initSearch();
    this.initCart();
    this.initProductForms();
    this.initLazyLoading();
    this.initScrollEffects();
  },

  // Mobile menu functionality
  initMobileMenu: function() {
    const mobileToggle = document.querySelector('.header__mobile-toggle');
    const nav = document.querySelector('.header__nav');
    
    if (mobileToggle && nav) {
      mobileToggle.addEventListener('click', function() {
        nav.classList.toggle('header__nav--open');
        mobileToggle.classList.toggle('header__mobile-toggle--open');
        document.body.classList.toggle('mobile-menu-open');
      });

      // Close mobile menu when clicking outside
      document.addEventListener('click', function(e) {
        if (!nav.contains(e.target) && !mobileToggle.contains(e.target)) {
          nav.classList.remove('header__nav--open');
          mobileToggle.classList.remove('header__mobile-toggle--open');
          document.body.classList.remove('mobile-menu-open');
        }
      });
    }
  },

  // Search functionality
  initSearch: function() {
    const searchToggle = document.querySelector('.header__search-toggle');
    const searchForm = document.querySelector('.search-form');
    
    if (searchToggle) {
      searchToggle.addEventListener('click', function() {
        if (searchForm) {
          searchForm.classList.toggle('search-form--open');
          const searchInput = searchForm.querySelector('input[type="search"]');
          if (searchInput) {
            searchInput.focus();
          }
        }
      });
    }
  },

  // Cart functionality
  initCart: function() {
    // Update cart count
    this.updateCartCount();
    
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.updateCartCount();
    });
  },

  // Update cart count in header
  updateCartCount: function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.getElementById('cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  },

  // Product form functionality
  initProductForms: function() {
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const addToCartButton = form.querySelector('button[type="submit"]');
        const originalText = addToCartButton.textContent;
        
        // Show loading state
        addToCartButton.textContent = 'Adding...';
        addToCartButton.disabled = true;
        
        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Show success message
          OceusTheme.showNotification('Product added to cart!', 'success');
          
          // Update cart count
          OceusTheme.updateCartCount();
          
          // Reset button
          addToCartButton.textContent = originalText;
          addToCartButton.disabled = false;
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          OceusTheme.showNotification('Error adding product to cart', 'error');
          
          // Reset button
          addToCartButton.textContent = originalText;
          addToCartButton.disabled = false;
        });
      });
    });
  },

  // Lazy loading for images
  initLazyLoading: function() {
    const images = document.querySelectorAll('img[data-src]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            img.classList.add('loaded');
            observer.unobserve(img);
          }
        });
      });

      images.forEach(img => imageObserver.observe(img));
    } else {
      // Fallback for older browsers
      images.forEach(img => {
        img.src = img.dataset.src;
        img.classList.remove('lazy');
        img.classList.add('loaded');
      });
    }
  },

  // Scroll effects
  initScrollEffects: function() {
    // Header scroll effect
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        // Scrolling down
        header.classList.add('header--hidden');
      } else {
        // Scrolling up
        header.classList.remove('header--hidden');
      }
      
      lastScrollTop = scrollTop;
    });

    // Fade in animation on scroll
    const fadeElements = document.querySelectorAll('.animate-on-scroll');
    
    if ('IntersectionObserver' in window) {
      const fadeObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      fadeElements.forEach(el => fadeObserver.observe(el));
    }
  },

  // Show notification
  showNotification: function(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    
    // Add styles
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#4CAF50' : type === 'error' ? '#f44336' : '#2196F3'};
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      transform: translateX(100%);
      transition: transform 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  },

  // Utility functions
  utils: {
    // Debounce function
    debounce: function(func, wait, immediate) {
      let timeout;
      return function executedFunction() {
        const context = this;
        const args = arguments;
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },

    // Throttle function
    throttle: function(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    },

    // Format currency
    formatMoney: function(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '${{amount}}';
      
      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';
        
        if (isNaN(number) || number === null) {
          return 0;
        }
        
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return parts.join(decimal);
      }
      
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      
      return formatString.replace(placeholderRegex, value);
    }
  }
};

// Initialize theme when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  OceusTheme.init();
});

// Initialize theme when Shopify theme editor loads
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function() {
    OceusTheme.init();
  });
}
